<template> 
  <div id="app">
    <modal-loader v-if="getLoader()"></modal-loader>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{
       
    }
  },
  mounted(){
    
  },
  created() {
  },
  
}
</script>


<style lang="scss">
  @import './assets/stylesheets/application.scss';
</style>


// WEBPACK FOOTER //
// src/App.vue